export const selectCurrentTime = (state) => state?.interviewVideo?.currentTime;
export const selectTimeToJump = (state) => state?.interviewVideo?.timeToJump;
export const selectToPlay = (state) => state?.interviewVideo?.toPlay;
export const selectIsPlaying = (state) => state?.interviewVideo?.isPlaying;
export const selectIsMinimized = (state) => state?.interviewVideo?.isMinimized;
export const selectIsMute = (state) => state?.interviewVideo?.isMute;
export const selectPlaybackSpeed = (state) =>
  state?.interviewVideo?.playbackSpeed;
export const selectProgress = (state) => state?.interviewVideo?.progress;
export const selectDuration = (state) => state?.interviewVideo?.duration;
export const selectIsPIPMode = (state) => state?.interviewVideo?.isPIPMode;
export const selectIsVideoModalOpen = (state) =>
  state?.interviewVideo?.isVideoModalOpen;
export const selectTranscriptTab = (state) =>
  state?.interviewVideo?.transcriptTab;
